import React, { memo } from 'react';
import { Section } from './Section';
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'CR',
    name: 'Claudia R.',
    location: 'Mendoza',
    text: 'El módulo de las 3am me lo sé de memoria. Ya no me agarro pánico cuando me despierto.'
  }, {
    initials: 'RM',
    name: 'Rocío M.',
    location: 'Buenos Aires',
    text: 'El ritual de 10 minutos lo hago todas las noches. Parece una tontería pero mi cuerpo ya sabe que es hora de dormir.'
  }, {
    initials: 'SC',
    name: 'Sofía C.',
    location: 'La Plata',
    text: 'Pensé que era ansiosa crónica. En 3 semanas dormí de corrido 5 noches seguidas. No me lo creía.'
  }, {
    initials: 'PA',
    name: 'Paula A.',
    location: 'Neuquén',
    text: 'El Diario de Descarga Mental me cambió los domingos a la noche. Ya no me acuesto con la cabeza llena.'
  }];
  return <Section className="bg-bgAlt py-20 px-4 sm:px-6 lg:px-8" data-id="element-263">
      <div className="max-w-6xl mx-auto" data-id="element-264">
        <h2 className="font-serif text-3xl md:text-4xl text-center text-headlineLight mb-16" data-id="element-265">
          ❤️ Mujeres que ya duermen diferente
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-266">
          {testimonials.map((t, i) => <div key={i} className="bg-[rgba(45,27,78,0.6)] border border-[rgba(232,197,245,0.2)] backdrop-blur-[10px] rounded-2xl p-8" data-id="element-267">
              <div className="flex items-center justify-between mb-6" data-id="element-268">
                <div className="flex items-center gap-4" data-id="element-269">
                  <div className="w-12 h-12 rounded-full bg-bgHero text-accentText flex items-center justify-center font-bold text-lg" data-id="element-270">
                    {t.initials}
                  </div>
                  <div data-id="element-271">
                    <p className="font-bold text-headlineLight" data-id="element-272">{t.name}</p>
                    <p className="text-sm text-accentText flex items-center gap-1" data-id="element-273">
                      <span data-id="element-274">📍</span> {t.location}
                    </p>
                  </div>
                </div>
                <div className="text-goldSoft text-sm" data-id="element-275">⭐⭐⭐⭐⭐</div>
              </div>
              <p className="text-bodyOnDark italic text-lg leading-relaxed" data-id="element-276">
                "{t.text}"
              </p>
            </div>)}
        </div>
      </div>
    </Section>;
}